(() => {
  const normalizeUpc = (value) => String(value || '').trim().replace(/^0(?=\d{12}$)/, '');

  async function fillBestsellers(configElement) {
    if (configElement.dataset.loaded) return;
    configElement.dataset.loaded = 'true';
    const grid = configElement.parentElement;
    const displayed = new Set(
      Array.from(grid.querySelectorAll('[data-bestseller-product-id]'), (card) => card.dataset.bestsellerProductId),
    );
    if (displayed.size >= 12) return;

    try {
      const config = JSON.parse(configElement.textContent);
      const upcs = [...new Set(config.upcs.map(normalizeUpc))];
      const searchTerms = upcs.flatMap((upc) => [upc, `0${upc}`]);
      const url = new URL(config.searchUrl, window.location.origin);
      url.searchParams.set('q', searchTerms.join(' OR '));
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[fields]', 'variants.barcode');
      url.searchParams.set('options[prefix]', 'none');
      url.searchParams.set('options[unavailable_products]', 'hide');
      url.searchParams.set('view', 'best-selling-fallback');

      // Shopify search order is unrelated to the supplied fallback priority.
      const candidates = [];
      let nextUrl = url;
      const visited = new Set();
      while (nextUrl && !visited.has(nextUrl.href)) {
        visited.add(nextUrl.href);
        const response = await fetch(nextUrl.href);
        if (!response.ok) throw new Error(`Bestseller search failed: ${response.status}`);
        const results = new DOMParser().parseFromString(await response.text(), 'text/html');
        const root = results.querySelector('[data-bestseller-fallback-results]');
        if (!root) throw new Error('Bestseller search template was not returned');
        candidates.push(...root.querySelectorAll('[data-bestseller-candidate]'));
        const next = root.querySelector('[data-bestseller-next]');
        nextUrl = next ? new URL(next.getAttribute('href'), url) : null;
        if (nextUrl) nextUrl.searchParams.set('view', 'best-selling-fallback');
      }

      for (const upc of upcs) {
        for (const candidate of candidates) {
          const barcodes = JSON.parse(candidate.dataset.barcodes).map(normalizeUpc);
          if (!barcodes.includes(upc)) continue;
          const card = candidate.content.querySelector('[data-bestseller-product-id]');
          if (!card || displayed.has(card.dataset.bestsellerProductId)) continue;
          const copy = document.importNode(card, true);
          const rank = displayed.size + 1;
          const badge = copy.querySelector('.vinyl-rank');
          badge.textContent = `#${rank}`;
          badge.setAttribute('aria-label', `Bestseller number ${rank}`);
          displayed.add(copy.dataset.bestsellerProductId);
          grid.insertBefore(copy, configElement);
          if (displayed.size === 12) return;
          break;
        }
      }
    } catch (error) {
      // Keep the server-rendered, in-stock collection cards if lookup fails.
      console.warn('Unable to fill best selling music:', error);
      delete configElement.dataset.loaded;
    }
  }

  function initialize(root = document) {
    root.querySelectorAll('[data-bestseller-config]').forEach(fillBestsellers);
  }

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
